import imgix from "@lonelyplanet/dotcom-core/dist/helpers/imgix";
import { find } from "lodash/collection";
import hotelProvider from "./hotelProvider";
import resourceTypes from "../../../server/lib/open-planet/resourceTypes";

/**
 * Gets the image object for the main object
 * @param {array} images An array of image objects with have a "tags" key
 * @return {{ tags: string[], links: { pixels: string } }}
 */
const getMainImage = images => {
  const mainImage = find(images, image => image.tags && image.tags.some(tag => tag === "main"));
  return mainImage || images[0];
};

/**
 * Gets the imgix parameters
 * @param {string} type Type of list data
 * @param {boolean} newExperience True if the collection is a new experience
 * @return {{ auto: string, crop: string, fit: string, h: number, q: number, w: number }}
 */
const getImgixParams = (type, newExperience) => {
  let width = 170;
  let height = 106;

  if (type === resourceTypes.collections && newExperience) {
    width = 300;
    height = 400;
  } else if (type === resourceTypes.lodging) {
    width = 189;
    height = 189;
  } else if (type === resourceTypes.partner_activity) {
    width = 128;
    height = 160;
  }

  return {
    auto: "enhance",
    crop: "entropy",
    fit: "crop",
    h: height,
    q: 50,
    w: width,
  };
};

/**
 * Gets the path for the correct lodging list image
 * @param {array | object} images The image(s) associated with the lodging
 * @param {object} imgixParams The params used to generate the image url
 * @param {object} providerType The provider of the lodging
 * @return {string} The url of the image to be displayed on the list page
 */
const getLodgingListImage = (images, imgixParams, providerType) => {
  if (Array.isArray(images) && images.length) {
    const mainImage = getMainImage(images);
    return imgix(mainImage.links.pixels, imgixParams, providerType);
  } else if (images && typeof images === "object") {
    return imgix(images.links.pixels, imgixParams, providerType);
  }

  return "";
};

/**
 * Gets the path for the correct poi list image
 * @param {array | object} imageAssociations The image(s) associated with the poi
 * @param {object} imgixParams The params used to generate the image url
 * @param {object} providerType The provider of the poi
 * @return {string} The url of the image to be displayed on the list page
 */
const getPoiListImage = (imageAssociations, imgixParams, providerType) => {
  let fromImage;

  if (Array.isArray(imageAssociations)) {
    fromImage = imageAssociations[0].from;
  } else if (imageAssociations.tag !== "food") {
    fromImage = imageAssociations.from;
  }

  if (fromImage) {
    return Array.isArray(fromImage)
      ? imgix(fromImage[0].links.pixels, imgixParams, providerType)
      : imgix(fromImage.links.pixels, imgixParams, providerType);
  }

  return "";
};

/**
 * Gets an image from a given resource
 * @param {any} resource An OP resource
 * @return {{ path?: string, orientation?: string }}
 */
export const getListImage = resource => {
  if (resource.type === resourceTypes.availability) {
    return getListImage(resource.lodging);
  }

  if (
    resource.imageAssociations ||
    resource.images ||
    (resource.links && resource.links.image) ||
    resource.providers
  ) {
    const isLodging = resource.type === resourceTypes.lodging;
    const isPartnerActivity = resource.type === resourceTypes.partner_activity;
    const imgixParams = getImgixParams(resource.type, resource.newExperience);
    const providerType = isLodging ? hotelProvider(resource.providers).type : "media";
    let imagePath = "";

    if (isPartnerActivity) {
      imagePath = imgix(resource.links.image, imgixParams, resource.provider);
    } else if (isLodging) {
      imagePath = getLodgingListImage(resource.images, imgixParams, providerType);
    } else {
      imagePath = getPoiListImage(resource.imageAssociations, imgixParams, providerType);
    }

    return {
      path: `${imagePath}`,
      orientation: isPartnerActivity ? "portrait" : "landscape",
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./assets/shared/getListImage.js